import { useQuery } from '@tanstack/react-query';

import { queryClient } from '@/services/query-client';

import * as dp from '../data-provider/quote-validation-schema';
import type { ValidationSchema, ValidationSchemaKey } from '../models';

export const useValidationSchema = (schemaKey: ValidationSchemaKey) => {
  return useQuery({
    queryFn: () => queryClient.ensureQueryData(dp.validationSchemasQueryOptions()),
    queryKey: ['validation-schema'],
    select: (data): ValidationSchema => {
      if (!data[schemaKey]) {
        throw new Error(`[validators]: ${schemaKey} has not found`);
      }
      return data[schemaKey] as ValidationSchema;
    },
    staleTime: 1000 * 60 * 60 * 1, // 1 hour
  });
};
